import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSuggestions } from 'bdvp-common/src/hooks';

import SavedList from './SavedList';
import { Typeahead } from './TypeaheadMultiSelect.styles';

const TypeaheadMultiSelect = (props) => {

    const {
        fields,
        onChange,
        componentConfig,
    } = props;

    const {
        selected,
        ...field
    } = fields[0];

    const [
        searchValue,
        setSearchValue,
    ] = useState('');

    const {
        suggestions,
        clearSuggestions,
    } = useSuggestions({
        value: searchValue,
        queryParams: {
            fieldId: componentConfig.typeaheadFieldId,
        },
        suggestionKeys: [componentConfig.suggestionsKey],
    });

    const onChangeHandler = (event) => {

        const inputValue = event.target.value;
        const isInputEmpty = inputValue === '';

        if (isInputEmpty) {

            clearSuggestions();

        }
        
        setSearchValue(inputValue);

    };

    const onItemClickHandler = (event, info) => {

        const { value, displayName } = suggestions[info.index];

        clearSuggestions();
        setSearchValue('');

        if (selected.some(element => element.value === value)) {

            return;

        }

        const selectedItem = {
            value,
            label: displayName,
        };
        const nextSelectedItems = [...selected];
        nextSelectedItems.push(selectedItem);

        onChange({
            changes: selectedItem,
            selected: nextSelectedItems,
            event: 'select-option',
        }, field);

    };

    const onRemoveItemButtonClickHandler = (selectedItem) => {

        const { value } = selectedItem;
        const nextSelectedItems = [...selected];
        const selectedIndex = selected.findIndex(element => element.value === value);
        nextSelectedItems.splice(selectedIndex, 1);

        onChange({
            changes: selectedItem,
            selected: nextSelectedItems,
            event: 'deselect-option',
        }, field);

    };

    const onClearInputHandler = (event, shouldResetValue) => {

        clearSuggestions();

        if(shouldResetValue) {

            setSearchValue('');

        }

    };

    return (
        <>
            <Typeahead
                placeholder={componentConfig.placeholder}
                onChange={onChangeHandler}
                onClearInput={onClearInputHandler}
                value={searchValue}
                suggestions={suggestions}
                onItemClick={onItemClickHandler}
                iconType={'search'}
            />
            {suggestions && suggestions.length === 0 && (
                <SavedList
                    selected={selected}
                    onRemoveItemButtonClick={onRemoveItemButtonClickHandler}
                />
            )}
        </>
    );

};

TypeaheadMultiSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    filterName: PropTypes.string,
    componentConfig: PropTypes.object,
};

TypeaheadMultiSelect.defaultProps = {
    filterName: '',
    componentConfig: {},
};

export default TypeaheadMultiSelect;
